<template>
  <div>
    <div class="columns">
      <div class="column is-2">
        <app-logo></app-logo>
      </div>
      <div class="column is-10">
        <div class="columns is-multiline">
          <div class="column is-4">
            <b-field :label="$t('adresseEmplacement.code')"
              :class="{'obligatoire' : !societeActive.masqueCodeEmplacement}">
              <b-input v-model="emplacement.code"></b-input>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field :label="$t('adresseEmplacement.libelle')"
              :class="{'obligatoire' : !isEmplacementAdresse()}">
              <b-input v-model="emplacement.libelle"></b-input>
            </b-field>
          </div>
          <div class="column is-4">
            <selectionAgence v-model="emplacement.agenceId" obligatoire
                             setFirstAgenceFind></selectionAgence>
          </div>
          <div class="column is-12">
            <b-field :label="$t('adresseEmplacement.description')">
              <b-input v-model="emplacement.description">
              </b-input>
            </b-field>
          </div>
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import Logo from '@/components/general/Logo';
import selectionAgence from '@/components/general/selectionAgence';

const Societe = createNamespacedHelpers('societe');

export default {
  name: 'headerCreationEmplacement',
  props: {
    emplacement: {
      type: Object,
      required: true,
    },
  },
  components: {
    appLogo: Logo,
    selectionAgence,
  },
  computed: {
    ...Societe.mapGetters({
      societeActive: 'societeActive',
    }),
  },
  methods: {
    isEmplacementAdresse() {
      return Object.prototype.hasOwnProperty.call(this.emplacement, 'emplacementAdresse');
    },
  },
};
</script>

<style scoped>

</style>
